import IconButton from 'components/common/IconButton';
import React from 'react';
import { Button } from 'react-bootstrap';

const buildSimpleButton = (button) => {
  return (
    <Button
      key={button.name}
      type={button.type}
      onClick={button.onClick}
      variant={button.variant || variant || 'falcon-default'}
      className={button.className || 'me-1 btn btn-sm'}
    >
      {button.name}
    </Button>
  );
};
const buildIconButton = (button) => {
  return (
    <IconButton
      key={button.name}
      type={button.type}
      onClick={button.onClick}
      variant={button.variant || variant || 'falcon-default'}
      className={button.className || 'me-1 btn btn-sm'}
      icon={button.icon}
      iconAlign="right"
      transform="shrink-3"
    >
      {button.name}
    </IconButton>
  );
};
function useButtonsGenerator(buttons) {
  return (
    <>
      {
        buttons.map((button, variant) => {
          if (button.icon !== undefined) {
            return buildIconButton(button);
          } else {
            return buildSimpleButton(button);
          }


        })}
    </>
  );
}

export default useButtonsGenerator;
